const EditorOpt = {
	formats: [
		"header",
		"indent",
		"list",
		"align",
		"direction",
		"bold",
		"italic",
		"size",
		"strike",
		"underline",
	],
	modules: {
		keyboard: {
			bindings: {
				shift_enter: {
					key: 13,
					shiftKey: true,
					handler: (range, ctx) => {
						this.editor.insertText(range.index, "\n");
					},
				},
			},
		},
		toolbar: [
			[{ header: [1, 2, 3, 4, 5, 6, false] }],
			[{ size: ["small", false, "large", "huge"] }],
			["bold", "italic", "underline", "strike"],
			[{ list: "ordered" }, { list: "bullet" }],
			[{ indent: "-1" }, { indent: "+1" }],
			[{ align: [] }],
			["clean"],
		],
	},
};

const Modals = {
	ATTACH: "ATTACH",
	CREATE: "CREATE",
	EDIT: "EDIT",
	INFO: "INFO",
	ROLE: "ROLE",
	STATUS: "STATUS",
};

const Patterns = {
	username: /^[A-Za-z0-9]([A-Za-z0-9_]{1,48})[A-Za-z0-9_]$/,
	urlname: /^[A-Za-z]([A-Za-z0-9-]{1,48})[A-Za-z0-9-]$/,
	mobile: /^(09)[0-9]{9}$/,
	email: /^\w+([-.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
	name: /^[A-Za-z\u0600-\u06FF\u200c][A-Za-z\u0600-\u06FF\u200c ]{1,48}[A-Za-z\u0600-\u06FF\u200c]$/,
	rolename:
		/^[A-Za-z0-9\u0600-\u06FF\u200c][0-9A-Za-z\u0600-\u06FF\u200c ]{1,48}[A-Za-z0-9\u0600-\u06FF\u200c]$/,
	latlong: /^[0-9]{2,3}(\.)[0-9]{6}$/,
	tag: /^[a-zA-Z0-9_\u0600-\u06FF\u200c]{2,20}$/,
};

const Permissions = {
	ABOUT_US_UPDATE: "admin_panel.about_us.update",
	ABOUT_US_VIEW: "admin_panel.about_us.view",

	BANNER_CREATE: "admin_panel.banner.create",
	BANNER_DELETE: "admin_panel.banner.delete",
	BANNER_STATUS: "admin_panel.banner.status",
	BANNER_UPDATE: "admin_panel.banner.update",
	BANNER_VIEW: "admin_panel.banner.view",

	CATEGORY_CREATE: "admin_panel.category.create",
	CATEGORY_DELETE: "admin_panel.category.delete",
	CATEGORY_STATUS: "admin_panel.category.status",
	CATEGORY_UPDATE: "admin_panel.category.update",
	CATEGORY_VIEW: "admin_panel.category.view",

	CONTACT_US_UPDATE: "admin_panel.contact_us.update",
	CONTACT_US_VIEW: "admin_panel.contact_us.view",

	FAQ_CREATE: "admin_panel.FAQ.create",
	FAQ_DELETE: "admin_panel.FAQ.delete",
	FAQ_STATUS: "admin_panel.FAQ.status",
	FAQ_UPDATE: "admin_panel.FAQ.update",
	FAQ_VIEW: "admin_panel.FAQ.view",

	JOB_CREATE: "admin_panel.job.create",
	JOB_DELETE: "admin_panel.job.delete",
	JOB_LADDER: "admin_panel.job.ladder",
	JOB_STATUS: "admin_panel.job.status",
	JOB_UPDATE: "admin_panel.job.update",
	JOB_VIEW: "admin_panel.job.view",

	NOTIFICATION_CREATE: "admin_panel.notification.create",
	NOTIFICATION_DELETE: "admin_panel.notification.delete",
	NOTIFICATION_STATUS: "admin_panel.notification.status",
	NOTIFICATION_UPDATE: "admin_panel.notification.update",
	NOTIFICATION_VIEW: "admin_panel.notification.view",

	PAYMENT_VIEW: "admin_panel.payment_confirmation.view",
	PAYMENT_STATUS: "admin_panel.payment_confirmation.status",

	USER_CREATE: "admin_panel.user.create",
	USER_DELETE: "admin_panel.user.delete",
	USER_STATUS: "admin_panel.user.status",
	USER_UPDATE: "admin_panel.user.update",
	USER_VIEW: "admin_panel.user.view",

	ROLE_ATTACH: "admin_panel.role.attach",
	ROLE_CREATE: "admin_panel.role.create",
	ROLE_DELETE: "admin_panel.role.delete",
	ROLE_STATUS: "admin_panel.role.status",
	ROLE_UPDATE: "admin_panel.role.update",
	ROLE_VIEW: "admin_panel.role.view",

	SETTING_UPDATE: "admin_panel.setting.update",
	SETTING_VIEW: "admin_panel.setting.view",

	SPECIAL_JOB_CREATE: "admin_panel.special_job.create",
	SPECIAL_JOB_DELETE: "admin_panel.special_job.delete",
	SPECIAL_JOB_UPDATE: "admin_panel.special_job.update",
	SPECIAL_JOB_VIEW: "admin_panel.special_job.view",

	SUBSCRIPTION_ATTACH: "admin_panel.subscription.attach",
	SUBSCRIPTION_CREATE: "admin_panel.subscription.create",
	SUBSCRIPTION_DELETE: "admin_panel.subscription.delete",
	SUBSCRIPTION_STATUS: "admin_panel.subscription.status",
	SUBSCRIPTION_UPDATE: "admin_panel.subscription.update",
	SUBSCRIPTION_VIEW: "admin_panel.subscription.view",

	SUPPORT_MESSAGE_VIEW: "admin_panel.support_message.view",

	TAC_UPDATE: "admin_panel.TAC.update",
	TAC_VIEW: "admin_panel.TAC.view",

	TRACKER_VIEW: "admin_panel.tracker.view",

	PLATFORM_VIEW: "admin_panel.platform.view",
	PLATFORM_CREATE: "admin_panel.platform.create",
	PLATFORM_UPDATE: "admin_panel.platform.update",
	PLATFORM_STATUS: "admin_panel.platform.status",
	PLATFORM_DELETE: "admin_panel.platform.delete",

	VERSION_VIEW: "admin_panel.version.view",
	VERSION_CREATE: "admin_panel.version.create",
	VERSION_UPDATE: "admin_panel.version.update",
	VERSION_DELETE: "admin_panel.version.delete",

	TRANSACTION_VIEW: "admin_panel.transaction.view",
};

const Status = {
	default: { active: "active", inactive: "inactive" },
	job: {
		neutral: "neutral",
		pending: "pending",
		approved: "approved",
		rejected: "rejected",
		suspended: "suspended",
	},
};

const Types = {
	status: { active: "active", pending: "pending" },
	upload: {
		banner: "banner",
		category: "category",
		default: "default",
		job: "job",
		user: "user",
	},
	uploadValidFormats: ["image/jpg", "image/jpeg", "image/png", "image/bmp"],
	banner: {
		category: "category",
		discount: "discount",
		home: "home",
		special: "special",
	},
	phoneNumbers: { fax: "fax", mobile: "mobile", phone: "phone" },
};

export { EditorOpt, Modals, Patterns, Permissions, Status, Types };
